<template>
  <div class="views-forum" v-if="showView">
    <rule-community v-if="showRules" @hide-rules="showRules = false" />
    <categories-forum v-else />
  </div>
</template>

<script>
import RuleCommunity from "@/components/forum/RuleCommunity";
import CategoriesForum from "@/components/forum/CategoriesForum";
export default {
  components: { RuleCommunity, CategoriesForum },
  data() {
    return {
      showRules: true,
      showView: false
    };
  },
  mounted() {
    this.$store.dispatch("forum/getCategoriesSelected").then(data => {
      if (!data.Category1 && !data.Category2 && !data.Category3) {
        this.showView = true;
      } else {
        this.$router.push({ name: "forum-feed" });
      }
    });
  }
};
</script>

<style scoped lang="scss">
.views-forum {
  background-image: url("../assets/images/forum/forum-bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
